module.exports = __webpack_public_path__ + "front/img/d5.8127a5a2.png";